export default "__VITE_ASSET__CzC$Gfu7__"